// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { HorizontalBar, defaults, Bar } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";

const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: true,
    onClick: null
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          display: true,
          labelString: "Major's Academic Division or School"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          //set the labels to stack when they're too long
          //so they don't overflow out of the card
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label;
              } else {
                return label.split(" ");
              }
            } else {
              return label;
            }
          }
        },
        stacked: false,
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Percent of Students"
        }
      }
    ]
  },
  title: {
    display: false,
  },
  tooltips:{
    callbacks:{
      label: function(tooltipItem){
        return this._data.datasets[tooltipItem.datasetIndex].label +': ' + tooltipItem.yLabel + '%';
      }
    }
  }
};

interface AcademicBreakdownProps {
  caption: string;
}

class AcademicBreakdownBarChartCard extends React.Component<AcademicBreakdownProps> {
  constructor(props: AcademicBreakdownProps){
    super(props);
  }
  state = {
    //using this as the data
    //hardcoded in 2020 bc couldn't make google sheets work
    labels: ["Humanities", "Life Sciences", "Physical Sciences", "Social Sciences", "Engineering", "Music", "Nursing", "Public Affairs", "Arts and Architecture", "Theater, Film, and Television", "Undeclared", "Other"],
    borderWidth: 1,
    datasets: [
      { data: [6.27, 31.62, 13.5, 26.72, 12.39, 1.28, 0.62, 0.66, 1.85, 1.07, 1.13, 2.9], backgroundColor: "#E84855",   label: "UCLA 2021 Undergraduates" },
      { data: [29.58, 23.24,12.68,17.61,7.75,0.70,0,2.11,2.82,1.41,2.11,0], backgroundColor: "#48A2D3", label: "Fall 2021 Interns" },
      { data: [32.75, 18.34, 9.61, 27.07, 7.86, 0.87, 0, 2.18, 0.87, 0.44, 0, 0], backgroundColor: "#F0A202", label: "Fall 2021 Contributors and Paid Staff" }
    ]
  };


  /*
  Humanities:	2066	6.27%
Life Sciences	10415	31.62%
Physical Sciences	4447	13.50%
Engineering	4081	12.39%
School of Music	421	1.28%
School of Public Affairs 	217	0.66%
School of the Arts and Architecture	609	1.85%
School of Theater, Film, and Television	351	1.07%
Social Sciences	8800	26.72%
Undeclared	373	1.13%
Nursing	203	0.62%
Other	956	2.90%
Total	32939	1
*/
  //collect the data
  collect_data = () => {
    // fetch(
    //   "https://spreadsheets.google.com/feeds/list/1P3ojuD3Rv8ZoTBUuNwEaOIkOodfRnybhahVnA9tl44E/od6/public/full?alt=json"
    // )
    //   .then(function(response) {
    //     return response.json();
    //   })
    //   .then((response_json: any) => {
    //     var labels = response_json.feed.entry.slice(0, 4).map((e: any) => {
    //       //console.log(e.gsx$section.$t);
    //       return e.gsx$gender.$t;
    //     });
    //     var values1 = response_json.feed.entry.slice(0, 4).map((e: any) => {
    //       //console.log(e.gsx$productsproduced.$t);
    //       return e.gsx$applicantgenderpercent.$t;
    //     });
    //     var values2 = response_json.feed.entry.slice(0, 4).map((e: any) => {
    //       //console.log(e.gsx$productsproduced.$t);
    //       return e.gsx$interngenderpercent.$t;
    //     });

    //     this.setState({
    //       labels: labels,
    //       datasets: [
    //         { data: values1, backgroundColor: "#0080C6", label: "Applicants" },
    //         {
    //           data: values2,
    //           backgroundColor: "#48A2D3",
    //           label: "Accepted Interns"
    //         }
    //       ]
    //     });
    //   })
    //   .catch(function(err) {
    //     console.log("something went wrong!", err);
    //   });
  };
  render() {
    //this.collect_data();
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Academic Breakdown
        </div>
        <div
          className={css`
            height: 600px;
            width: 100%;
          `}
        >
          <Bar
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: center;
          `}
        >
          {caption}
        </div>
      </Card>
    );
  }
}

export default AcademicBreakdownBarChartCard;
